import { AfterViewInit, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'loading-ticket-dialog',
  templateUrl: '../sharedTemplates/loading-ticket.dialog.html',
})
export class LoadingTicketDialog implements AfterViewInit {
  constructor(private _UiHelper: UiHelper, public dialogRef: MatDialogRef<LoadingTicketDialog>) {}

  ngAfterViewInit(): void {
    this._UiHelper.loadingDialogListener.subscribe(x => {
      if (!x) {
        this.dialogRef.close();
      }
    });
  }
}
